import { CLink, CTableDataCell, CTableRow, CTooltip } from '@coreui/react-pro'
import React from 'react'

const ShowCommonScorecard = (props) => {
  const dropdownCol1 = [
    { key: 'rs' },
    { key: 'bf' },
    { key: 'fours' },
    { key: 'sixes' },
    { key: 'overs' },
    { key: 'mdns' },
    { key: 'run' },
    { key: 'wks' },
    { key: 'cs' },
    { key: 'cwks' },
    { key: 'sts' },
    { key: 'rods' },
    { key: 'roas' },
  ]
  const dropdownCol2 = [{ key: 'dks' }, { key: 'hattrick' }, { key: 'no' }]
  const dropdownCol3 = [{ key: 'hwot' }]
  const dropdownCol4 = [
    { key: 'wb' },
    { key: 'wct' },
    { key: 'wcwk' },
    { key: 'wlbw' },
    { key: 'wst' },
    { key: 'whw' },
    { key: 'dotp' },
    { key: 'dotb' },
  ]

  const hwotOption = {
    hwot: 'Bowled',
    hoct: 'Catch',
    hocwk: 'Catch WK',
    holbw: 'LBW',
    host: 'Stump',
    horod: 'RO-Direct',
    horoa: 'RO-Assist',
    hohw: 'Hit Wicket',
    hohb: 'Handled-Ball',
    hoobs: 'Obstruct',
    hotmd: 'Timed',
  }
  return (
    <>
      <table className="main-table table innertable">
        <thead>
          <tr>
            <th
              style={{
                position: 'sticky',
                left: 0,
                zIndex: 2,
                backgroundColor: '#fff',
                width: '5%', // Adjust width as needed
              }}
            >
              PLAYER
            </th>
            <th width="5%">FP</th>
            {props.scorecardColoumns.map((value, key) => (
              <>
                <th key={value?.id}>
                  <CTooltip content={value?.full_name}>
                    <CLink> {value?.label} </CLink>
                  </CTooltip>
                </th>
              </>
            ))}
          </tr>
        </thead>
        <tbody>
          {props.scorecardDetails &&
            props.scorecardDetails.map((item, key) => (
              <CTableRow key={key}>
                <CTableDataCell>{item.player_name}</CTableDataCell>
                <CTableDataCell>{item.fantasy_points}</CTableDataCell>
                {props.scorecardColoumns
                  .filter((value) =>
                    dropdownCol1.some((dropdown) => dropdown.key === value?.attribute_key),
                  )
                  .map((value, key) => (
                    <>
                      <CTableDataCell>{item[value?.attribute_key]}</CTableDataCell>
                    </>
                  ))}

                {props.scorecardColoumns
                  .filter((value) =>
                    dropdownCol2.some((dropdown) => dropdown.key === value?.attribute_key),
                  )
                  .map((value, key) => (
                    <>
                      <CTableDataCell>
                        {item[value?.attribute_key] ? <span>Yes</span> : <span>No</span>}
                      </CTableDataCell>
                    </>
                  ))}

                {props.scorecardColoumns
                  .filter((value) =>
                    dropdownCol3.some((dropdown) => dropdown.key === value?.attribute_key),
                  )
                  .map((value, key) => (
                    <>
                      <CTableDataCell>{hwotOption[item.hwot]}</CTableDataCell>
                    </>
                  ))}
                {props.scorecardColoumns
                  .filter((value) =>
                    dropdownCol4.some((dropdown) => dropdown.key === value?.attribute_key),
                  )
                  .map((value, key) => (
                    <>
                      <CTableDataCell>
                        {item[value?.attribute_key] === 0 ? <span>No</span> : <span>Yes</span>}
                      </CTableDataCell>
                    </>
                  ))}
              </CTableRow>
            ))}
        </tbody>
      </table>
    </>
  )
}

export default ShowCommonScorecard
